module.exports = __webpack_public_path__ + "static/media/showcase_night_mobile.9f3a814d.png";